import request from './AxiosRequest' // eslint-disable-line

function getProjectEdit(
    project_id
) {
    return request({
        url: `/users/favorites/${favorite_type}/${favorite_id}`,
        data: favoriteData,
        //headers: { 'X-CSRFToken': window.ajax_csrf_token },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest'
        },
        method: 'POST'
    })
}

function getProjectMembers(
    project_id
) {
    return request({
        url: `/api/project-members/${project_id}/project/`,
        headers: {'X-CSRFToken': window.ajax_csrf_token},
        method: 'GET'
    })
}


function createOrUpdateProjectMember(
    project_id, project_member
) {
    if (Object.hasOwn(project_member, 'id')) {
        return request({
            url: `/api/project-members/${project_member.id}/`,
            headers: {'X-CSRFToken': window.ajax_csrf_token},
            data: project_member,
            method: 'PUT'
        })
    } else {
        return request({
            url: `/api/project-members/${project_id}/project/`,
            headers: {'X-CSRFToken': window.ajax_csrf_token},
            data: project_member,
            method: 'POST'
        })
    }
}


function getCompanyEmployees(company_id) {
    return request({
        url: `/api/company-employees/${company_id}/employees/`,
        headers: {'X-CSRFToken': window.ajax_csrf_token},
        method: 'GET'
    })
}

function createOrUpdateCompanyEmployee(
    company_id, employee
) {
    if (Object.hasOwn(employee, 'id')) {
        return request({
            url: `/api/company-employees/${employee.id}/`,
            headers: {'X-CSRFToken': window.ajax_csrf_token},
            data: employee,
            method: 'PUT'
        })
    } else {
        return request({
            url: `/api/company-employees/${company_id}/employees/`,
            headers: {'X-CSRFToken': window.ajax_csrf_token},
            data: employee,
            method: 'POST'
        })
    }
}

function deleteCompanyEmployee(
    company_id, employee
) {
    if (Object.hasOwn(employee, 'id')) {
        return request({
            url: `/api/company-employees/${employee.id}/`,
            headers: {'X-CSRFToken': window.ajax_csrf_token},
            data: employee,
            method: 'DELETE'
        })
    }
}

function createOrUpdateFavorite(
    favorite_type,
    favorite_id,
    favoriteData
) {
    return request({
        url: `/users/favorites/${favorite_type}/${favorite_id}`,
        data: favoriteData,
        //headers: { 'X-CSRFToken': window.ajax_csrf_token },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest'
        },
        method: 'POST'
    })
}

function getProfileStatsByRange(profile_id, profile_type, start_date, end_date) {
    return request({
        url: `/api/profile-stats/me?profile_id=${profile_id}&start_date=${start_date}&end_date=${end_date}&type=${profile_type}`,
        //headers: { 'X-CSRFToken': window.ajax_csrf_token },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest'
        },
        method: 'GET'
    })
}

function createPartnerMessage(
    messageData
) {
    return request({
        url: `/api/messages/`,
        headers: {'X-CSRFToken': window.ajax_csrf_token},
        data: messageData,
        method: 'POST'
    })

}

const WINWorker = {
    createOrUpdateFavorite,
    getProjectMembers,
    getCompanyEmployees,
    createOrUpdateCompanyEmployee,
    deleteCompanyEmployee,
    createOrUpdateProjectMember,
    getProfileStatsByRange,
    createPartnerMessage
}

export default WINWorker
